export default "__VITE_ASSET__DBp54GC4__"